module.exports = __webpack_public_path__ + "static/media/LegalConsentforChild-AdolescentClients.0b33ae71.pdf";